import { useState } from "react"
import Link from "@/components/link"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import { sessionEditUserOptions } from "@/redux/_session.actions"
import { userUpdateOptions } from "@/redux/user.actions"
import { UserOptions } from "@/redux/user.types"
import { faCircleNotch, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useRisksSpace } from "@/core/risks-space.context"

export default function PhysicalRiskCalculationsToggle() {
  const dispatch = useAppDispatch()
  const { isReadonly } = useRisksSpace()
  const userId = useAppSelector((state) => state._session.userId)
  const userOptions = useAppSelector((state) => state._session.userOptions)
  const showCalculations = userOptions.risksShowCalculations
  const [isSaving, setIsSaving] = useState(false)

  async function toggleCalculations() {
    if (isSaving) return

    const nextValue = !showCalculations
    dispatch(sessionEditUserOptions("risksShowCalculations", nextValue))
    if (isReadonly) return

    const nextOptions = new UserOptions({
      ...userOptions,
      risksShowCalculations: nextValue
    })

    setIsSaving(true)

    try {
      await Promise.all([
        dispatch(userUpdateOptions(userId, nextOptions)),
        new Promise((resolve) => setTimeout(resolve, 250))
      ])
    } finally {
      setIsSaving(false)
    }
  }

  return (
    <div className="my-auto flex items-center gap-[5px]">
      <Link icon={showCalculations ? faEyeSlash : faEye} isWithoutMargin onClick={toggleCalculations}>
        {showCalculations ? "Masquer le détail des calculs" : "Afficher le détail des calculs"}
      </Link>
      {isSaving && <FontAwesomeIcon className="grey-t" icon={faCircleNotch} spin />}
    </div>
  )
}
